<div class="card">
  <div class="card-body py-4">
    <div
      class="flex flex-wrap items-center justify-between gap-2"
      [class.mb-4]="!collapsed"
    >
      <span class="card-title pb-1">
        <span
          class="inline-block h-6 w-6 cursor-pointer"
          (click)="collapsed = !collapsed"
        >
          @if (collapsed) {
            <app-chevron-right-icon></app-chevron-right-icon>
          } @else {
            <app-chevron-down-icon></app-chevron-down-icon>
          }
        </span>
        Sent Activation Key Emails</span
      >
      <button
        type="button"
        class="btn btn-outline btn-sm"
        [class.hidden]="collapsed"
        [disabled]="loading || !tenantId"
        (click)="load()"
      >
        @if (loading) {
          <span class="loading loading-spinner loading-sm"></span>
        }
        Refresh
      </button>
    </div>

    <div [class.hidden]="collapsed">
      @if (error) {
        <p class="text-error">{{ error }}</p>
      } @else if (loading && items.length === 0) {
        <div class="skeleton h-32 w-full"></div>
      } @else if (items.length === 0) {
        <p>No activation key emails have been sent for this tenant.</p>
      } @else {
        <div class="flex flex-col gap-4">
          @for (item of items; track item.id) {
            <div class="rounded-lg border border-base-content/20 p-4">
              <div class="flex flex-wrap justify-between text-sm">
                <div>
                  <div class="mb-3">
                    <div class="field-label mb-1">Emails</div>
                    <div class="flex flex-wrap gap-2">
                      <span>{{ displayEmailList(item.emails) }}</span>
                    </div>
                  </div>

                  <div>
                    @if (item.licenses.length > 0) {
                      <div class="field-label mb-1">Licenses</div>
                      <ul>
                        @for (license of item.licenses; track $index) {
                          <li>
                            @if (
                              license.product_title && license.product_code
                            ) {
                              <span>{{ license.product_code }} -</span>
                            }
                            {{ licenseLabel(license) }}
                            (Exp.
                            {{ license.expiration_date | date: 'MM/dd/yyyy' }}
                            - UID: {{ license.unique_id }})
                          </li>
                        }
                      </ul>
                    }
                    @if (item.standalone_activation_keys?.length) {
                      <div
                        class="field-label mb-1"
                        [class.mt-3]="item.licenses.length > 0"
                      >
                        One-off keys
                      </div>
                      <ul>
                        @for (
                          key of item.standalone_activation_keys;
                          track key.id
                        ) {
                          <li>
                            @if (key.product_title && key.product_code) {
                              <span>{{ key.product_code }} -</span>
                            }
                            {{ standaloneKeyLabel(key) }}
                            (Exp.
                            {{
                              key.expiration_date | date: 'MM/dd/yyyy' : 'UTC'
                            }}
                            - UID: {{ key.unique_id }})
                          </li>
                        }
                      </ul>
                    }
                    @if (
                      item.licenses.length === 0 &&
                      !item.standalone_activation_keys?.length
                    ) {
                      <p class="opacity-70">No licenses recorded</p>
                    }
                  </div>
                </div>
                <div class="text-right">
                  <div class="mb-3">
                    <div class="field-label mb-1">Sent</div>
                    <div>
                      {{ item.sent_at | date: 'MM/dd/yyyy h:mm a' }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="field-label mb-1">Type</div>
                    <div>
                      @if (item.sent_as_transfer) {
                        Transfer email
                      } @else {
                        Activation key email
                      }
                    </div>
                  </div>
                  @if (item.sent_by_email || item.sent_by_username) {
                    <div>
                      <div class="field-label mb-1">Sent by</div>
                      <div>
                        {{ item.sent_by_email }}
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
